export default __webpack_public_path__ + "i18n/translations/translation-th.f4287728.json";